export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20" style={{
      backgroundImage: 'url(https://readdy.ai/api/search-image?query=Bright%20cheerful%20cooking%20class%20kitchen%20scene%20with%20fresh%20colorful%20vegetables%20and%20ingredients%20arranged%20beautifully%20on%20wooden%20cutting%20board%2C%20warm%20natural%20sunlight%20streaming%20through%20windows%2C%20cozy%20home%20kitchen%20atmosphere%20with%20herbs%20and%20cooking%20utensils%2C%20inviting%20culinary%20learning%20environment%2C%20soft%20pastel%20colors%20with%20orange%20and%20cream%20tones%2C%20magazine%20editorial%20style%20food%20photography%20with%20artistic%20composition&width=1920&height=1080&seq=hero-cooking-bg&orientation=landscape)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-orange-50/90 to-transparent"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-white px-5 py-2.5 rounded-full shadow-lg mb-6 border-2 border-orange-300" style={{ borderStyle: 'dashed' }}>
            <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
            <span className="text-orange-600 font-medium" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              沼津市の楽しい料理教室
            </span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: '"Klee One", cursive' }}>
            料理って、<br />
            こんなに楽しい！
          </h2>
          
          <p className="text-xl text-gray-700 mb-8 leading-relaxed" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            シルバー料理教室では、初心者の方から料理好きの方まで、みんなが笑顔になれるレッスンをご用意しています。教室でも、ご自宅でも、あなたのペースで料理の楽しさを発見しましょう！
          </p>
          
          <div className="flex flex-wrap gap-4 mb-12">
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-8 py-4 rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer font-bold shadow-lg"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
            >
              <i className="ri-mail-line mr-2"></i>
              お問い合わせ
            </button>
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-orange-600 px-8 py-4 rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer font-bold shadow-lg border-3 border-orange-400"
              style={{ fontFamily: '"Zen Maru Gothic", sans-serif', borderWidth: '3px' }}
            >
              <i className="ri-book-open-line mr-2"></i>
              レッスンを見る
            </button>
          </div>

          <div className="grid grid-cols-3 gap-6">
            <div className="bg-white p-5 rounded-2xl shadow-lg border-3 border-orange-200 text-center" style={{ borderStyle: 'dashed', borderWidth: '3px' }}>
              <div className="text-3xl font-bold text-orange-500 mb-1" style={{ fontFamily: '"Klee One", cursive' }}>
                初心者OK
              </div>
              <div className="text-sm text-gray-600" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                安心サポート
              </div>
            </div>
            <div className="bg-white p-5 rounded-2xl shadow-lg border-3 border-red-200 text-center" style={{ borderStyle: 'dashed', borderWidth: '3px' }}>
              <div className="text-3xl font-bold text-red-500 mb-1" style={{ fontFamily: '"Klee One", cursive' }}>
                訪問型
              </div>
              <div className="text-sm text-gray-600" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                ご自宅でレッスン
              </div>
            </div>
            <div className="bg-white p-5 rounded-2xl shadow-lg border-3 border-yellow-200 text-center" style={{ borderStyle: 'dashed', borderWidth: '3px' }}>
              <div className="text-3xl font-bold text-yellow-600 mb-1" style={{ fontFamily: '"Klee One", cursive' }}>
                食育指導
              </div>
              <div className="text-sm text-gray-600" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                食材選びから
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-orange-400"></i>
      </div>
    </section>
  );
}
